import React from "react";
import { formatDate, formatTimeFromTS } from "../utils/format";

export default function OrderTimeline({
  timeline,
  selectedStep,
  setSelectedStep,
}) {
  return (
    <>
      <div style={{ marginTop: 16 }}>
        {timeline.map((evento, i) => (
          <div
            key={i}
            style={{
              marginBottom: 10,
              padding: 12,
              background: "#fff",
              borderRadius: 8,
              boxShadow: "0 2px 4px rgba(0,0,0,0.08)",
              cursor: "pointer",
            }}
            onClick={() => setSelectedStep(evento)}
          >
            <b>{evento.tipo}</b> — Fecha: {formatDate(evento.fecha)}{" "}
            {evento.ts ? formatTimeFromTS(evento.ts) : ""} — Nro:{" "}
            {evento.numero} — Cantidad: {evento.cantidad}
            {evento.tipo === "📥 Pedido" && evento.pendiente > 0 && (
              <>
                {" "}
                —{" "}
                <span style={{ color: "crimson", fontWeight: 600 }}>
                  Pendiente: {evento.pendiente}
                </span>
              </>
            )}
            {/* Mostrar la fecha de entrega real si aplica */}
            {evento.tipo?.includes("Remito") && evento.entrega_real && (
              <div
                style={{
                  marginTop: 6,
                  display: "flex",
                  alignItems: "center",
                  gap: 6,
                }}
              >
                <span style={{ fontSize: 18 }}>✅</span>
                <span>
                  <b>Entrega real:</b> {formatDate(evento.entrega_real)}
                </span>
              </div>
            )}
          </div>
        ))}
      </div>

      {selectedStep && (
        <div
          onClick={() => setSelectedStep(null)}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              background: "#fff",
              borderRadius: 12,
              padding: 24,
              width: 500,
              maxHeight: "80vh",
              overflowY: "auto",
            }}
          >
            <h3>
              {selectedStep.tipo} — {formatDate(selectedStep.fecha)}{" "}
              {selectedStep.ts ? formatTimeFromTS(selectedStep.ts) : ""}
            </h3>

            {selectedStep.tipo?.includes("Remito") &&
              selectedStep.entrega_real && (
                <p style={{ marginTop: 8 }}>
                  <b>Entrega Real:</b> {formatDate(selectedStep.entrega_real)}
                </p>
              )}

            {selectedStep.data.map((item, i) => (
              <div
                key={i}
                style={{
                  borderBottom: "1px solid #eee",
                  marginBottom: 10,
                  paddingBottom: 10,
                }}
              >
                <b>Producto:</b> {item.ItemCode}
                <br />
                <b>Descripción:</b> {item.Dscription}
                <br />
                <b>Cantidad:</b> {item.Quantity}
                {item["Cantidad Pendiente"] > 0 && (
                  <>
                    <br />
                    <b style={{ color: "crimson" }}>Pendiente:</b>{" "}
                    {item["Cantidad Pendiente"]}
                  </>
                )}
              </div>
            ))}

            <button
              onClick={() => setSelectedStep(null)}
              style={{
                marginTop: 12,
                background: "#2D3748",
                color: "#fff",
                padding: "8px 16px",
                border: "none",
                borderRadius: 8,
                cursor: "pointer",
              }}
            >
              Cerrar
            </button>
          </div>
        </div>
      )}
    </>
  );
}
